import { Checkbox, FormControlLabel } from "@mui/material";
import { purple } from "@mui/material/colors";
import React, { useEffect } from "react";
import { Card, CloseButton, Col, Form, Row } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import Select from "react-select";
import guestIcon from "../../assets/svg/icon-guest.svg";
import PortalModal from "../../Portals/PortalModal.jsx";
import PointersLine from "../Loaders/PointersLine/PointersLine.jsx";
import {
  ButtonCancel,
  ButtonCreateGroup,
  ContentSelect,
  CounterTotalUsers,
  FormCard,
  Hr,
  IconGuest,
  SectionWrapper,
  SelectStyles,
  TextTitleList,
} from "./ModalAdvanceOptions.styled.js";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const ModalAdvanceOptions = ({
  fieldLabel = "",
  selectedUsers,
  closeAdvanceSearch,
  allCountries,
  handleChangeSelectCountry,
  handleChangeComoNoComo,
  rCountries,
  rRoles,
  rLobs,
  rCities,
  allCities,
  handleChangeSelectCity,
  loadingRoleByLevel,
  errorRoleByLevel,
  allRolesByLevel,
  handleChangeSelectRole,
  setSelectedRole,
  allLobs,
  handleChangeSelectLob,
  usersAdvanceSearch,
  createGroup,
  showCheckboxes = false,
  selectedCheckbox,
  setSelectedCheckbox,
  loadingUsersOfAdvanceSearch,
  rComoNonComo,
}) => {
  const comoNoComo = [
    { value: 1, label: "Como" },
    { value: 2, label: "Non Como" },
  ];

  useEffect(() => {
    if (allRolesByLevel.length > 0 && fieldLabel === "Approve users") {
      let selectedItems = allRolesByLevel.map((element) => {
        return element.value;
      });
      setSelectedRole({
        roles: allRolesByLevel,
        roleIds: selectedItems,
      });
      let initialRoles = allRolesByLevel.map((role) => {
        return {
          value: `${role.value}`,
          label: `${role.label}`,
        };
      });
      rRoles.current.state.selectValue = initialRoles;
      rRoles.current.state.ariaSelection = initialRoles;
    }
  }, [allRolesByLevel]);

  return (
    <PortalModal>
      <FormCard>
        <InfiniteScroll
          dataLength={selectedUsers.length}
          height="fit-content"
          loader={<h4>Loading...</h4>}
        >
          {showCheckboxes && (
            <>
              <Row className="d-flex justify-content-around">
                <Col md="6">
                  <TextTitleList className="font-weight-bold mx-2 my-2">
                    Select Fields for report
                  </TextTitleList>
                </Col>
                <Col
                  md="6"
                  className="d-flex justify-content-end align-items-center"
                >
                  <CloseButton
                    onClick={() => closeAdvanceSearch()}
                  ></CloseButton>
                </Col>
              </Row>
              <Row className="mx-2 mt-2">
                <Hr className="mt-0" />
                <Col md="12">
                  <p>Please select all the fields you want for your report</p>
                </Col>
                <Col md="6">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.user}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: !selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="User (First and last name)"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.client}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: !selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="Client"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.country}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: !selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="Country"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.city}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: !selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="City"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.role}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: !selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="Role"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.lob}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: !selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="Lob"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.tpid}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: !selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="TP Id"
                  />
                </Col>
                <Col md="3">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.username}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: !selectedCheckbox.username,
                            userstatus: selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="Username"
                  />
                </Col>
                <Col md="4">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={selectedCheckbox.userstatus}
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        onClick={() =>
                          setSelectedCheckbox({
                            user: selectedCheckbox.user,
                            client: selectedCheckbox.client,
                            country: selectedCheckbox.country,
                            city: selectedCheckbox.city,
                            role: selectedCheckbox.role,
                            lob: selectedCheckbox.lob,
                            tpid: selectedCheckbox.tpid,
                            username: selectedCheckbox.username,
                            userstatus: !selectedCheckbox.userstatus,
                          })
                        }
                      />
                    }
                    label="User Status"
                  />
                </Col>
                <Hr className="mt-0" />
              </Row>
            </>
          )}
          <Row className="d-flex justify-content-around">
            <Col md="6">
              <TextTitleList className="font-weight-bold mx-2 my-2" onClick={() => createGroup()}>
                Create Group
              </TextTitleList>
            </Col>
            <Col
              md="6"
              className="d-flex justify-content-end align-items-center"
            >
              {!showCheckboxes && (
                <CloseButton onClick={() => closeAdvanceSearch()}></CloseButton>
              )}
            </Col>
          </Row>
          <Row className="mx-2 mt-2">
            <Hr className="mt-0" />
            <Col md="12">
              <ContentSelect>
                <Row>
                  <Col md="6">
                    <Form.Label className="font-weight-bold d-flex justify-content-start">
                      Select Country
                    </Form.Label>
                  </Col>
                  <Col md="6" className="d-flex justify-content-end">
                    <Form.Label>Only Option</Form.Label>
                  </Col>
                  <Col md="12">
                    <Select
                      placeholder="Select one option"
                      ref={rCountries}
                      options={allCountries}
                      styles={SelectStyles}
                      onChange={handleChangeSelectCountry}
                    />
                  </Col>
                </Row>
              </ContentSelect>
            </Col>
            <Col md="12" className="my-1">
              <ContentSelect>
                <Row>
                  <Col md="6">
                    <Form.Label className="font-weight-bold d-flex justify-content-start">
                      Select City
                    </Form.Label>
                  </Col>
                  <Col md="6" className="d-flex justify-content-end">
                    <Form.Label>Multiple selection option</Form.Label>
                  </Col>
                  <Col md="12">
                    <Select
                      placeholder="Select one option"
                      isMulti
                      ref={rCities}
                      options={allCities}
                      styles={SelectStyles}
                      onChange={handleChangeSelectCity}
                    />
                  </Col>
                </Row>
              </ContentSelect>
            </Col>
            <Col md="12" className="my-1">
              <ContentSelect>
                {loadingRoleByLevel && (
                  <Row>
                    <Col md="12" className="d-flex justify-content-center">
                      <PointersLine color={themeConfig.text.primary} />
                    </Col>
                  </Row>
                )}
                {errorRoleByLevel && <option key="0">Error :(</option>}
                {!loadingRoleByLevel && !errorRoleByLevel && (
                  <Row>
                    <Col md="6">
                      <Form.Label className="font-weight-bold d-flex justify-content-start">
                        Select Role
                      </Form.Label>
                    </Col>
                    <Col md="6" className="d-flex justify-content-end">
                      <Form.Label>Multiple selection option</Form.Label>
                    </Col>
                    <Col md="12">
                      <Select
                        placeholder="Select one option"
                        isMulti
                        ref={rRoles}
                        options={allRolesByLevel}
                        styles={SelectStyles}
                        onChange={handleChangeSelectRole}
                      />
                    </Col>
                  </Row>
                )}
              </ContentSelect>
            </Col>
            <Col md="12">
              <ContentSelect>
                <Row>
                  <Col md="6">
                    <Form.Label className="font-weight-bold d-flex justify-content-start">
                      Como /Non Como
                    </Form.Label>
                  </Col>
                  <Col md="6" className="d-flex justify-content-end">
                    <Form.Label>Only Option</Form.Label>
                  </Col>
                  <Col md="12">
                    <Select
                      placeholder="Select one option"
                      ref={rComoNonComo}
                      options={comoNoComo}
                      styles={SelectStyles}
                      onChange={handleChangeComoNoComo}
                    />
                  </Col>
                </Row>
              </ContentSelect>
            </Col>
            <Col md="12" className="my-1">
              <ContentSelect>
                <Row>
                  <Col md="6">
                    <Form.Label className="font-weight-bold d-flex justify-content-start">
                      LOB
                    </Form.Label>
                  </Col>
                  <Col md="6" className="d-flex justify-content-end">
                    <Form.Label>Multiple selection option</Form.Label>
                  </Col>
                  <Col md="12">
                    <Select
                      placeholder="Select one option"
                      isMulti
                      ref={rLobs}
                      options={allLobs}
                      styles={SelectStyles}
                      onChange={handleChangeSelectLob}
                    />
                  </Col>
                </Row>
              </ContentSelect>
            </Col>
            <Col md="12">
              <Card className="d-flex flex-column-reverse">
                <Row className="m-3">
                  {loadingUsersOfAdvanceSearch ? (
                    <Col
                      md="12"
                      className="d-flex justify-content-center align-content-center my-5"
                    >
                      <PointersLine color={themeConfig.text.primary} />
                    </Col>
                  ) : (
                    <Col
                      className="text-center d-flex align-items-md-center"
                      md="8"
                    >
                      <IconGuest className="mr-2" src={guestIcon}></IconGuest>{" "}
                      Total users:{" "}
                      <CounterTotalUsers className="ml-2">
                        {rCountries?.current?.state?.ariaSelection?.value
                          ?.value ||
                        rCities?.current?.state?.ariaSelection?.value?.value ||
                        rRoles?.current?.state?.ariaSelection?.value?.value ||
                        rLobs?.current?.state?.ariaSelection?.value?.value ||
                        rComoNonComo?.current?.state?.ariaSelection?.value
                          ?.value
                          ? usersAdvanceSearch.length
                          : 0}
                      </CounterTotalUsers>
                    </Col>
                  )}
                </Row>
              </Card>
            </Col>
            <Col md="12" className="my-1">
              <SectionWrapper>
                <Row className="d-flex justify-content-end">
                  <Col md="4">
                    <ButtonCancel onClick={() => closeAdvanceSearch()}>
                      Cancel
                    </ButtonCancel>
                  </Col>
                  <Col md="4">
                    <ButtonCreateGroup onClick={() => createGroup()}>
                      Create Group
                    </ButtonCreateGroup>
                  </Col>
                </Row>
              </SectionWrapper>
            </Col>
          </Row>
        </InfiniteScroll>
      </FormCard>
    </PortalModal>
  );
};

ModalAdvanceOptions.propTypes = {
  fieldLabel: PropTypes.string,
  selectedUsers: PropTypes.array,
  closeAdvanceSearch: PropTypes.func,
  allCountries: PropTypes.array,
  handleChangeSelectCountry: PropTypes.func,
  rCountries: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  rCities: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  rRoles: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  rLobs: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  allCities: PropTypes.array,
  handleChangeSelectCity: PropTypes.func,
  loadingRoleByLevel: PropTypes.bool,
  errorRoleByLevel: PropTypes.bool,
  allRolesByLevel: PropTypes.array,
  handleChangeSelectRole: PropTypes.func,
  setSelectedRole: PropTypes.func,
  allLobs: PropTypes.array,
  handleChangeSelectLob: PropTypes.func,
  usersAdvanceSearch: PropTypes.array,
  createGroup: PropTypes.func,
  rSelectedUsers: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  handleChangeComoNoComo: PropTypes.func,
  rComoNonComo: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  showCheckboxes: PropTypes.bool,
  selectedCheckbox: PropTypes.object,
  setSelectedCheckbox: PropTypes.func,
  loadingUsersOfAdvanceSearch: PropTypes.bool,
}

export default ModalAdvanceOptions;
